import React from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';
const Spinner = ({ message, showMessage, style, showLarge }) => (React.createElement("div", { "data-testid": "div-30d558f2", className: "flex justify-center" },
    React.createElement("i", { "data-testid": "i-ddeb4756", style: style, className: classnames({ 'text-5xl': showLarge, fa: true, 'fa-spinner': true, 'fa-spin': true, 'mx-auto': true, 'text-green': true }) }),
    showMessage && React.createElement("span", { "data-testid": "span-28023fae", className: "pl-2" }, message)));
Spinner.propTypes = {
    message: propTypes.string,
    showMessage: propTypes.bool,
    style: propTypes.object,
};
Spinner.defaultProps = {
    message: 'Loading...',
    showMessage: true,
    style: {},
};
export default Spinner;
